import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import styles from './styles.css';

export const LoadingView: React.FC = () => {
  return (
    <div className={styles['container']}>
      <span className={styles['wrapper']}>
        <Spinner size={50} />
      </span>
    </div>
  );
};
